var LETTERS_DICTIONARY = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'i',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'u',
  я: 'ya',
  А: 'A',
  Б: 'B',
  В: 'V',
  Г: 'G',
  Д: 'D',
  Е: 'E',
  Ё: 'E',
  Ж: 'Zh',
  З: 'Z',
  И: 'I',
  Й: 'I',
  К: 'K',
  Л: 'L',
  М: 'M',
  Н: 'N',
  О: 'O',
  П: 'P',
  Р: 'R',
  С: 'S',
  Т: 'T',
  У: 'U',
  Ф: 'F',
  Х: 'H',
  Ц: 'C',
  Ч: 'Ch',
  Ш: 'Sh',
  Щ: 'Sch',
  Ъ: '',
  Ы: 'Y',
  Ь: '',
  Э: 'E',
  Ю: 'U',
  Я: 'Ya'
};
export var getTransliteratedEngWord = function getTransliteratedEngWord(word) {
  return word.split('').map(function (sym) {
    var _LETTERS_DICTIONARY$s;
    return (_LETTERS_DICTIONARY$s = LETTERS_DICTIONARY[sym]) !== null && _LETTERS_DICTIONARY$s !== void 0 ? _LETTERS_DICTIONARY$s : sym;
  }).join('');
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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